// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminDashboardContainer {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.adminHeader {
  background-color: white;
  height: 60px;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.adminTitle {
  color: #FF6F0F;
  margin: 0;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.2s;
}

.adminTitle:hover {
  color: #FF6F0F;
}

.adminContent {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.adminMainContent {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}

.admin-logout-button {
  background-color: white !important;
  color: #FF6F0F !important;
  border: 1px solid #FF6F0F !important;
  border-radius: 20px !important;
  padding: 8px 25px !important;
  font-size: 14px;
  transition: all 0.3s;
  width: 146px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.admin-logout-button:hover {
  background-color: #FFF5E9;
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".adminDashboardContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.adminHeader {\n  background-color: white;\n  height: 60px;\n  border-bottom: 1px solid #e1e1e1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n}\n\n.adminTitle {\n  color: #FF6F0F;\n  margin: 0;\n  font-size: 24px;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.adminTitle:hover {\n  color: #FF6F0F;\n}\n\n.adminContent {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.adminMainContent {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.admin-logout-button {\n  background-color: white !important;\n  color: #FF6F0F !important;\n  border: 1px solid #FF6F0F !important;\n  border-radius: 20px !important;\n  padding: 8px 25px !important;\n  font-size: 14px;\n  transition: all 0.3s;\n  width: 146px;\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.admin-logout-button:hover {\n  background-color: #FFF5E9;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
